export const getSaleMasterList = state => {
    return state.list
}

export const getSaleMasterDataProps = state => {
    return state.props
}

export const getItemAutocompleteList = state => {
    return state.item_autocomplete_list
}

export const getSaleMasterOutstandingList = state => {
    return state.outstanding_list
}


// WEBPACK FOOTER //
// ./src/store/modules/saleMaster/getters.js